<template>
  <div>
    <vs-table
      data-cy="table"
      stripe
      class="box-table"
      :data="substitutes"
      noDataText="Sin registros encontrados"
    >
      <template slot="thead" class="bg-primary">
        <vs-th>Nombre</vs-th>
        <vs-th>Inicio</vs-th>
        <vs-th>Fin</vs-th>
        <vs-th>...</vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr
          data-cy="file"
          :key="indextr"
          v-for="(tr, indextr) in data"
        >
          <vs-td :data="data[indextr].remplazaNombre">
          <span class="d-flex">
            <span class="ml-3" style="line-height: 40px;">
              {{data[indextr].remplazaNombre}}
            </span>
          </span>
          </vs-td>
          <vs-td :data="data[indextr].remplazoInicio">
            {{data[indextr].remplazoInicio | dateFormat}}
          </vs-td>
          <vs-td :data="data[indextr].remplazoFin">
            {{data[indextr].remplazoFin | dateFormat }}
          </vs-td>
          <vs-td :data="data[indextr].remplazaNombre">
            <div class="">
              <b-button
                data-cy="edit-substitution"
                v-tooltip="'Editar suplente'"
                variant="flat-primary"
                class="btn-icon rounded-circle"
                v-show="data[indextr].estado.toString() === '5'"
                @click="editSubstitue(data[indextr])"
              >
                <feather-icon
                  size="18"
                  icon="EditIcon"
                  class="align-middle text-body p-0"
                />
              </b-button>
              <b-button
                data-cy="pause-substitution"
                v-tooltip="'Pausar suplencia'"
                variant="flat-warning"
                class="btn-icon rounded-circle"
                v-if="data[indextr].estado.toString() === '1'"
                @click="disableSubstitute(data[indextr])"
              >
                <feather-icon
                  size="18"
                  icon="PauseCircleIcon"
                  class="align-middle text-body p-0"
                  variant="danger"
                />
              </b-button>
              <b-button
                data-cy="resume-substitution"
                v-tooltip="'Retomar suplencia'"
                variant="flat-success"
                class="btn-icon rounded-circle"
                v-if="data[indextr].estado.toString() === '5'"
                @click="enableSubstitute(data[indextr])"
              >
                <feather-icon
                  size="18"
                  icon="PlayCircleIcon"
                  class="align-middle text-body p-0"
                />
              </b-button>
              <b-button
                data-cy="resume-substitution"
                v-tooltip="'Procesando cambio en suplencia'"
                variant="flat-warning"
                class="btn-icon rounded-circle"
                v-if="data[indextr].estado.toString() !== '5' &&
                 data[indextr].estado.toString() !== '1'"
              >
                <feather-icon
                  size="18"
                  icon="LoaderIcon"
                  class="align-middle text-body p-0"
                />
              </b-button>
              <b-button
                data-cy="file-substitution"
                v-tooltip="'Archivar suplencia'"
                variant="flat-danger"
                class="btn-icon rounded-circle"
                v-if="data[indextr].estado.toString() === '5'"
                @click="storeSubstitute(data[indextr])"
              >
                <feather-icon
                  size="18"
                  icon="XCircleIcon"
                  class="align-middle text-body p-0"
                />
              </b-button>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>
<script>

import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    ...mapGetters('Empresas', [
      'substitutes',
      'company'
    ]),
  },
  methods: {
    ...mapActions('Empresas', [
      'getSubstituteUser',
      'addSubstituteUser'
    ]),
    editSubstitue(user) {
      this.$emit('edit-substitute', user);
    },
    disableSubstitute(user) {
      this.$emit('disable-substitute', user);
    },
    storeSubstitute(user) {
      this.$emit('store-substitute', user);
    },
    enableSubstitute(user) {
      this.$emit('enable-substitute', user);
    },
  }
};
</script>
<style>

.box-table {
  max-height: 280px;
  overflow-y: auto;
}
</style>
